// Copyright 2019 Sorama B.V.

import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";
import { Unit } from "units/Unit";
import { UnitParser as Parser } from "units/UnitParser";

export class UnitParser implements IWorkflowPropertyParser<Unit> {
    toWorkflowProperty(object: Unit): string {
        if (object == undefined) return undefined;

        return object.unit;
    }

    fromWorkflowProperty(str: string): Unit {
        return Parser.Parse(str);
    }
}
